<template>
  <div class="inputStyle">
    <!-- TODO - bug valeurs réinitialisé
    <b-tooltip
      :label="$t('dataTypeAuthorizations.interval')"
      position="is-right"
    >
      <b-field
        class="btnRadio"
        style="margin-bottom: 1rem"
      >
        <b-radio-button
          v-model="isInterval"
          :aria-label="$t('rules.for-value')"
          :native-value="false"
          size="is-small"
          type="is-primary is-outlined"
        >
          <span>{{ $t("rules.for-value") }}</span>
        </b-radio-button>
        <b-radio-button
          v-model="isInterval"
          :aria-label="$t('rules.for-interval')"
          :native-value="true"
          size="is-small"
          type="is-primary is-outlined"
        >
          <span>{{ $t("rules.for-interval") }}</span>
        </b-radio-button>
      </b-field>
    </b-tooltip>-->
    <div
      v-if="isInterval"
      class="rows"
    >
      <InputDateInterval
        v-if="type === 'DateChecker'"
        :format="format"
        :input-type="inputType"
        :has-extraction="true"
        @update:size-height="changeValueSizeHeight(isInterval, $event)"
        @update:date-value-interval="submit($event)"
        @update:validity="$emit('update:validity', $event)"
      />
      <InputNumberInterval
        v-if="type === 'FloatChecker' || type === 'IntegerChecker'"
        :format="type === 'FloatChecker' ? 'float' : 'integer'"
        :from="fromNumber"
        :input-type="type === 'FloatChecker' ? 'float' : 'integer'"
        :max="max"
        :min="min"
        :to="toNumber"
        @update:number-value-interval="submit($event)"
        @update:validity="$emit('update:validity', $event)"
      />
    </div>
    <div v-else>
      <InputNumber
        v-if="type === 'FloatChecker' || type === 'IntegerChecker'"
        :format="type === 'FloatChecker' ? 'float' : 'integer'"
        :from="fromNumber"
        :input-type="type === 'FloatChecker' ? 'float' : 'integer'"
        :is-simple-value="true"
        :max="max"
        :min="min"
        @update:number-value="submit($event)"
      />

      <DatePatternInput
        v-if="type === 'DateChecker'"
        v-model="fromDate"
        aria-hidden="false"
        :pattern="format"
        type="startDate"
        @input="submit({ isSimpleValue: true, filter: $event })"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted, ref, watch } from "vue";
import useRegex from "@/composable/components/regex";
import useText from "@/composable/components/text";
import useNumber from "@/composable/components/number";
import useDate from "@/composable/components/date";
import useBoolean from "@/composable/components/boolean";
import InputDateInterval from "@/components/common/provider/InputDateInterval.vue";
import InputNumberInterval from "@/components/common/provider/InputNumberInterval.vue";
import InputNumber from "@/components/common/provider/InputNumber.vue";
import DatePatternInput from "@/components/forms/DatePatternInput.vue";
import { } from "buefy"; // BRadioButton, BField, BTooltip supprimés (non utilisés dans le template)
import "@/style/components/FilterNumberOrDate.scss";

export default {
  name: "FilterNumberOrDate",
  components: { DatePatternInput, InputNumber, InputNumberInterval, InputDateInterval },
  props: {
    modelValue: Object,
  },
  emits: ["update:modelValue", "sizeHeight", "update:validity"],
  setup(props, ctx) {
    watch(
      () => props.modelValue,
      (value) => {
        // #476 - Ne plus forcer isInterval = true sur tous les filtres
        // Laisser le composant parent decider du mode (intervalle ou valeur simple)
        if (value.isInterval === undefined) {
          value.isInterval = true;
        }
        changeIsInterval(value.isInterval);
        if (type.value === "DateChecker" && value?.value) {
          fromDate.value
            = (value.isInterval ? value?.value?.intervalValues?.from : value?.value?.simpleValue)
              || null;
          toDate.value
            = (value.isInterval ? value?.value?.intervalValues?.to : value?.value?.simpleValue)
              || null;
        }
        else if ((value.type === "FloatChecker" || value.type === "IntegerChecker") && value?.value) {
          fromNumber.value
            = (value.isInterval ? value?.value?.intervalValues?.from : value?.value?.simpleValue)
              || 0;
          toNumber.value
            = (value.isInterval ? value?.value?.intervalValues?.to : value?.value?.simpleValue) || 0;
        }
      },
    );
    const { refText: type, doChangeText: changeType } = useText();
    const { refText: format, doChangeText: changeFormat } = useText();
    const { doChangeText: changeComponent } = useText();
    const { refBoolean: isInterval, doChangeBoolean: changeIsInterval } = useBoolean(true);
    const { doChangeText: changeKey } = useText();
    const { refText: from } = useText();
    const { refText: to } = useText();
    const { refDate: fromDate } = useDate(null);
    const { refDate: toDate } = useDate(null);
    // #476 P4 - null = champ vide (placeholder affiche au lieu de 0)
    const fromNumber = ref<number | null>(null);
    const toNumber = ref<number | null>(null);
    const { refNumber: min } = useNumber(
      props.modelValue.checker.min && props.modelValue.checker.min !== "-Infinity"
        ? props.modelValue.checker.min
        : Number(-Infinity),
    );
    const { refNumber: max } = useNumber(
      props.modelValue.checker.max && props.modelValue.checker.max !== "Infinity"
        ? props.modelValue.checker.max
        : Number(Infinity),
    );

    const { refText: inputType, doChangeText: changeInputType } = useText("text");
    const { refRegex: pattern, doChangeRegex: changePattern } = useRegex();

    onMounted(() => {
      if (props.modelValue) {
        changeType(props.modelValue.checker.type);
        changeFormat(props.modelValue.checker.pattern);
        changeComponent(props.modelValue.component);
        changeIsInterval(props.modelValue.isInterval ? props.modelValue.isInterval : true);
        changeKey(props.modelValue.key);
      }
      let t = { date: false, time: false, isNumeric: false };
      if (type.value === "FloatChecker" || type.value === "IntegerChecker") {
        if (format.value === "integer") {
          t.isNumeric = true;
          changePattern(/(?<=\s|^)[-+]?\d+(?=\s|$)/);
        }
        if (format.value === "float") {
          t.isNumeric = true;
          changePattern(/^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/);
        }
      }
      if (t.date && t.time) {
        changeInputType("datetime");
      }
      else if (t.date) {
        changeInputType("date");
      }
      else if (t.time) {
        changeInputType("time");
      }
      else if (t.isNumeric) {
        changeInputType("number");
      }
    });

    function submit(event) {
      if (event && event.isSimpleValue) {
        from.value = event.filter;
      }
      else if (event && event.interval) {
        from.value = event.interval.from;
        to.value = event.interval.to;
      }
      let value = isInterval.value
        ? {
            intervalValues: {
              from: from.value,
              to: to.value,
            },
          }
        : {
            simpleValue: from.value,
          };
      ctx.emit("update:modelValue", {
        ...props.modelValue,
        type: type.value,
        inputType: inputType.value,
        format: format.value,
        intervalValues: value.intervalValues,
        simpleValue: value.simpleValue,
        isInterval: isInterval.value,
      });
    }

    function changeValueSizeHeight(collapside, event) {
      isInterval.value = collapside;
      if (event) {
        ctx.emit("sizeHeight", {
          value: event,
        });
      }
      return isInterval.value;
    }

    return {
      submit,
      changeValueSizeHeight,
      inputType,
      format,
      pattern,
      to,
      from,
      type,
      fromNumber,
      toNumber,
      toDate,
      fromDate,
      min,
      max,
      isInterval,
    };
  },
};
</script>
